import { useContext } from "react";
import { Text } from "../../components/text/text";
import { LocaleContext } from "../../contexts/locale/locale";
import { Page } from "../page/page";

export const Imprint = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<Page title={texts.imprint.hero.title} image="/images/home.jpg">
			<Text
				title={texts.imprint.hero.title}
				paragraphs={texts.imprint.paragraphs}
			/>
		</Page>
	);
};
